import { useContext } from 'react';
import { TextsetContext } from '@/contexts/TextSetContext/entry';
import { TextsetContextValueType } from '@/contexts/TextSetContext/types';

type UseTextsetContextReturn = Omit<
  TextsetContextValueType,
  'handleOuterState'
> & {
  changeOuterState: TextsetContextValueType['handleOuterState'];
  dataKeyName: 'texts';
  apiKeyName: 'textsets';
  dynamicName: 'textset';
};

export function useTextsetContext(): UseTextsetContextReturn {
  const {
    apiName,
    page,
    searchTextsPerPage,
    term,
    termType,
    complexity,
    textLength,
    data,
    patientId,
    setId,
    limitModal,
    editData,
    selectedData,
    handleOuterState,
    changePage,
    changeLimitModal,
    changeData,
    changeSelectedData,
    refetchTexts,
    tags,
    scrollViewRef,
  } = useContext(TextsetContext);

  return {
    apiName,
    term,
    termType,
    searchTextsPerPage,
    page,
    complexity,
    limitModal,
    patientId,
    setId,
    editData,
    data,
    selectedData,
    textLength,
    changeOuterState: handleOuterState,
    changePage,
    changeLimitModal,
    changeData,
    changeSelectedData,
    refetchTexts,
    dataKeyName: 'texts',
    apiKeyName: 'textsets',
    dynamicName: 'textset',
    tags,
    scrollViewRef,
  };
}
